module.exports = __webpack_public_path__ + "img/HeatingCircuitOptimization.e474ae3d.png";